var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_vm._v("Postcodes")]),_c('hr'),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.text2)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }